import EditReport from "./component";
import EditReportContainer from "./container";

export { EditReport, EditReportContainer };
export default EditReportContainer;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/EditReport/index.ts